import { render, staticRenderFns } from "./TableAllAssets.vue?vue&type=template&id=53031532&scoped=true"
import script from "./TableAllAssets.vue?vue&type=script&lang=js"
export * from "./TableAllAssets.vue?vue&type=script&lang=js"
import style0 from "./TableAllAssets.vue?vue&type=style&index=0&id=53031532&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53031532",
  null
  
)

export default component.exports